import React from 'react';
import { inject, observer } from 'mobx-react';
import uniqueId from 'lodash/uniqueId';
import { toJS } from 'mobx';
import {
  Icon, Button,
} from 'antd';
import RichTextArea from '../../../coms/rich/RichTextArea';
import util from '../../../util/index';
const { isWeaver } = util;
const isweaver = isWeaver();
const store = ['modeListStore', 'appDetailStore'];
@inject(...store)
@observer
class App extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      open: false,
      toName: '',
      ds_fid: '',
      ds_fnum: '',
    }
  }
  getDsType = (dstype) => {
    if (dstype === '0') return "普通";
		else if(dstype === '1') return "咨询";
		else if(dstype === '2') return "需求";
		else if(dstype === '3') return "问题";
		return "普通";
  }

  getName = (num) => {
    const { data, subdata } = this.props;
    const res = subdata.filter(v => v.ds_num === num);
    if (data.ds_num === num) return data.m_name;
    else if (res && res.length > 0) return res[0].m_name;
    return '';
  }

  setOpen = (v, id, num) => {
    this.setState({ open: true, toName: v, ds_fid: id, ds_fnum: num });
  }

  onSubmit = () => {
    const { ds_fid, ds_fnum } = this.state;
    const { modeListStore: { appDetail }, appDetailStore: { addDeb }, form } = this.props;
    const params = {
      sw_id: toJS(appDetail).app.sw_id, 
      s_number: toJS(appDetail).app.s_number, 
      s_id: toJS(appDetail).app.s_id,
      ds_replayContent: form.getFieldValue('ds_replayContent'),
      ds_content: form.getFieldValue('ds_replayContent'),
      ds_fid,
      ds_fnum,
    }
    addDeb(params).then(() => {
      form.resetFields();
      this.setState({ open: false });
      this.dcContent && this.dcContent.clear();
    });
  }

  render() {
    const { open, toName } = this.state;
    const { data, prefixCls, subdata, form } = this.props;
    const { getFieldProps } = form;
    return (
      <div className={`${prefixCls}-con`}>
        <div className={prefixCls}>
          <div className={`${prefixCls}-title`}>
            <span className={`${prefixCls}-subContent-title-name`}>{data.m_name}</span>
            <span>({data.comname})</span>
            <span>{data.ds_createtime}</span>
            <span>{this.getDsType(data.ds_type)}</span>
            <span>{data.ds_score}分</span>
          </div>
          <div className={`${prefixCls}-content`}>
            <span dangerouslySetInnerHTML={{__html: data.ds_content}} />
          </div>
          {
            isweaver && (
              <div className={`${prefixCls}-title-icon`} onClick={() => this.setOpen(data.m_name, data.ds_id, data.ds_num)}>
                <Icon type="message" theme="twoTone" />回复
              </div>
            )
          }
        </div>
        {
          isweaver && subdata && subdata.length > 0 && (
            <div className={`${prefixCls}-subContent`}>
              {
                subdata.map(v => (
                  <div key={v.ds_id} className={`${prefixCls}-subContent-con`}>
                    <div className={`${prefixCls}-subContent-title`}>
                      <span className={`${prefixCls}-subContent-title-name`}>{v.m_name}</span>
                      <span>({v.comname})</span>
                      <span>{v.ds_createtime}</span>
                      <span>回复</span>
                      <span className={`${prefixCls}-subContent-title-name`}>{this.getName(v.ds_fnum)}</span>
                    </div>
                    <div className={`${prefixCls}-content`}>
                      <span dangerouslySetInnerHTML={{__html: v.ds_content}} />
                    </div>
                    <div className={`${prefixCls}-title-icon`} onClick={() => this.setOpen(v.m_name, v.ds_fid, v.ds_num)}>
                      <Icon type="message" theme="twoTone" />回复
                    </div>
                  </div>
                ))
              }
            </div>
          )
        }
        {
          open && isweaver && (
            <div className={`${prefixCls}-comment`}>
              <div className={`${prefixCls}-comment-name`}>
                <span>回复</span>
                <span>{toName}:</span>
              </div>
              <div className={`${prefixCls}-comment-btn`}>
                <Button type="primary" size="small" onClick={this.onSubmit}>提交</Button>
                <Button size="small" onClick={() => this.setState({ open: false })}>取消</Button>
              </div>
              <RichTextArea
                {...getFieldProps("ds_replayContent")}
                id={uniqueId("dsContent")}
                ref={(el) => this.dcContent = el}
                pluginOptions={{
                  toolbar: [
                    ['Bold', 'Italic', 'Underline', 'Strike'],
                    ['Cut', 'Copy', 'Paste'],
                    ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', 'Blockquote'],
                    ['Image'],
                    ['Table'],
                    ['tools'],
                    ['Styles', 'Format', 'Font', 'FontSize'],
                    ['TextColor', 'BGColor']
                  ],
                height: "80px"
              }} />
            </div>
          )
        }
      </div>
    )
  }
}

export default App;


// WEBPACK FOOTER //
// ./src/components/mode/appDetail/CommentReplyBox.js